// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"Colleges_MainLayout__1mHow","Pagination":"Colleges_Pagination__ISTfU"};